/**
 * Get subtext of a string
 * @param {string} text string
 * @param {number} length optional
 * @returns {string}
 */
export function getSubText (text: string, length:number=20): string {
    return text.length > length ? `${text.substring(0,length)}...` : `${text}...`;
}


/**
* get parse date
* @param {string} input date in YYYY-MM-DD format
* @returns {number} date in EPOC format
*/
export function getParsedEPOCDate (input: string): number {  
    const [year, month, day] = input.split('-');
    const result = [month, day, year].join('/');
    return Date.parse(result);
  }

/**
 * Returns date in YYYY-MM-DD format
 * @param {Date} input_date 
 * @returns {string} YYYY-MM-DD
 */
export function getDateInStringFormat (input_date: Date): string {    
    return input_date.toISOString().substring(0, 10);    
}

/**
 * Util function to extract vendor information
 * @param inputText 
 * @returns {string} vendor
 */
export function retrieveVendor(inputText: string): string {
    if (inputText.length === 0) return '';
    const index = inputText.indexOf("|");  
    return inputText.substring(0, index);
}